/**
 * Vantage Core API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { PagedModelRequest } from './pagedModelRequest';
import { LocationLinkDetailsViewModel } from './locationLinkDetailsViewModel';
import { PagedListMetaData } from './pagedListMetaData';

export interface LocationLinkDetailsViewModelPagedModelResponse {
  pagedRequest?: PagedModelRequest;
  data?: Array<LocationLinkDetailsViewModel> | null;
  metaData?: PagedListMetaData;
}
